import {FontSizes, FontWeights, IconButton, SharedColors} from "@fluentui/react";
import {Link} from "react-router-dom";
import * as React from "react";

function ReturnBack(props) {
    return (
        <Link to={props.to}><IconButton iconProps={{iconName: 'back'}} /></Link>
    )
}

export default ReturnBack;